import React from 'react';
import Regularsponsors from '../component/regularsponsor';
import Partner from '../component/partner';
import Trust from '../component/Trusties';
export default class Rsponsors extends React.Component {
  constructor() {
    super();
    this.state = {color: "red"};
  }
  render() {
    return (
         <>
         <Regularsponsors/>
         <Partner/>
         <Trust/>;
         </>
    );
  }
}
